var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#42A5F5",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26229 14.4131C6.37166 14.0303 6.59041 13.6748 6.86385 13.4014L15.1763 5.08887C15.8599 4.40527 16.981 4.40527 17.6646 5.08887L18.731 6.15527C18.8131 6.2373 18.8951 6.34668 18.9498 6.42871C19.4146 7.1123 19.3326 8.04199 18.731 8.64355L10.4185 16.9561C10.3912 16.9834 10.3365 17.0107 10.3092 17.0654C10.0357 17.2842 9.73494 17.4482 9.40682 17.5576L6.09822 18.5146C5.87947 18.5967 5.63338 18.542 5.46932 18.3506C5.27791 18.1865 5.22322 17.9404 5.27791 17.7217L6.26229 14.4131ZM6.89119 16.9287L9.02401 16.2998C9.07869 16.2725 9.16072 16.2451 9.21541 16.2178L8.23104 16.0264C8.01229 15.9717 7.82088 15.8076 7.79354 15.5889L7.60213 14.6045C7.57479 14.6592 7.54744 14.7412 7.5201 14.7959L6.89119 16.9287ZM10.1998 15.3154L15.7506 9.76465L14.0279 8.06934L8.50447 13.6201L8.77791 15.0146L10.1998 15.3154Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilRecharge);
export default __webpack_public_path__ + "static/media/pencil-recharge.ae939741f9f5bbed1d7531715e489a2f.svg";
export { ForwardRef as ReactComponent };